module.exports = __webpack_public_path__ + "media/images/mobile/abouts/fz-35023369e6bd3832967061c7ea40dfad.png";